import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import ToastrMessage from "../../js/toastrMessage";
import SummerNoteJs from "../../js/summernote";
import axios from "axios";
import Select from "react-select";

const WNLawAddService = () => {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [category, setCategory] = useState();
  const [isValidTitle, setIsValidTitle] = useState(true);
  const [isValidContent, setIsValidContent] = useState(true);
  const [isValidCategory, setIsValidCategory] = useState(true);
  const [msg, setMsg] = useState("");
  const API_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();

  const options = [
    { value: "Litigation", label: "Litigation" },
    {
      value: "Non Litigation And Legal Counseling",
      label: "Non Litigation And Legal Counseling",
    },
    {
      value: "Alternative Dispute Resolution",
      label: "Alternative Dispute Resolution",
    },
    {
      value: "Additional Services",
      label: "Additional Services",
    },
  ];

  const saveServices = async (e) => {
    e.preventDefault();

    try {
      if (!title || !content || !category) {
        if (!title) {
          setIsValidTitle(false);
          // setValidToastrId(false);
        }
        if (!content) {
          setIsValidContent(false);
          // setValidToastrId(false);
        }

        if (!category) {
          setIsValidCategory(false);
          // setValidToastrId(false);
        }
        return;
      }
      await axios.post(`${API_URL}/services`, {
        title: title,
        content: content,
        category: category,
      });
      navigate("/form/services", { replace: true });
    } catch (error) {
      console.log("Error save services : ", error);
      if (error.response && error.response.data && error.response.data.msg) {
        setMsg(error.response.data.msg);
      } else {
        setMsg("An error occurred while saving the services.");
      }
    }
  };

  useEffect(() => {
    SummerNoteJs();
    console.log("category updated:", category);
  }, [category]);

  return (
    <div class="main-content">
      <section class="section">
        <div class="section-header">
          <div class="section-header-back">
            <Link to="/form/services" class="btn btn-icon">
              <i class="fas fa-arrow-left"></i>
            </Link>
          </div>
          <h1>Add Services</h1>
          <div class="section-header-breadcrumb">
            <div class="breadcrumb-item active">
              <a href="/dashboard/general">Dashboard</a>
            </div>
            <div class="breadcrumb-item">
              <Link to="#">Document</Link>
            </div>
            <div class="breadcrumb-item active">
              <Link to="/form/services">Services</Link>
            </div>
            <div class="breadcrumb-item">Add Services</div>
          </div>
        </div>
        <div class="section-body">
          <h2 class="section-title">{title}</h2>
          <p class="section-lead">
            Add information about your service on this page.
          </p>

          <div class="row mt-sm-4">
            <div class="col-12 col-md-12 col-lg-12">
              <div class="card">
                <form class="needs-validation" novalidate="">
                  <div class="card-header">
                    <h4>Add Services</h4>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="form-group col-md-6 col-12">
                        Title&nbsp;<span style={{ color: "red" }}>*</span>{" "}
                        <input
                          type="text"
                          className={`form-control ${
                            !isValidTitle ? "is-invalid" : ""
                          }`}
                          onChange={(event) => {
                            setTitle(event.target.value);
                            setIsValidTitle(true);
                          }}
                          value={title}
                          required
                        />
                        {!isValidTitle && (
                          <div class="invalid-feedback">
                            Please fill in the title
                          </div>
                        )}
                      </div>
                      <div class="form-group col-md-6 col-12">
                        Category&nbsp;<span style={{ color: "red" }}>*</span>{" "}
                        <div>
                          <Select
                            options={options}
                            value={options.find(
                              (option) => option.value === category
                            )}
                            onChange={(selectedOption) => {
                              setCategory(selectedOption.value);
                              setIsValidCategory(true);
                            }}
                          />
                          {!isValidCategory && (
                            <div style={{ color: "red" }}>
                              Please fill in the category
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-md-12 col-12">
                        Description&nbsp;<span style={{ color: "red" }}>*</span>{" "}
                        <textarea
                          className={`form-control ${
                            !isValidContent ? "is-invalid" : ""
                          }`}
                          style={{ minHeight: "300px", resize: "none" }}
                          value={content}
                          onChange={(event) => {
                            setContent(event.target.value);
                            setIsValidContent(true);
                          }}
                          rows={10}
                        ></textarea>
                        {/* Show validation error message when necessary */}
                        {/* Assuming you want to validate the content */}
                        {/* Adjust the condition accordingly */}
                        {!isValidContent && (
                          <div className="invalid-feedback">
                            Please fill in the description.
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div class="card-footer text-right">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      id="toastr-9"
                      data-toggle="modal"
                      onClick={(e) => saveServices(e)}
                    >
                      Save Changes
                    </button>
                  </div>
                </form>
                {/* <div class="card-footer text-right">
                    <button
                      className="btn btn-primary"
                      data-toggle="modal"
                      // data-target="#exampleModal"
                    >
                      Save Changes
                    </button>
                  </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="modal fade" tabIndex="-1" role="dialog" id="exampleModal">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Modal title</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p>Modal body text goes here.</p>
            </div>
            <div className="modal-footer bg-whitesmoke br">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                // data-dismiss="modal"
                onClick={saveServices}
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WNLawAddService;
